// extracted by mini-css-extract-plugin
export default {"container":"quizboard_container__yRAdo","table":"quizboard_table__PtBDi"};